<template>
  <v-row>
    <v-col cols="12" lg="6" class="py-0">
      <v-card v-if="patientConditions">
        <v-card-title>
          <div class="flex-grow-1">
            {{ this.patientConditions.diagnostic ? this.patientConditions.diagnostic.length : 0 }}
            Diagnostic Condition(s)
          </div>
        </v-card-title>

        <v-skeleton-loader :loading="loading" max-width="275" type="card">
          <v-virtual-scroll
            :items="patientConditions.diagnostic"
            :item-height="40"
            bench="5"
            height="200"
          >
            <template v-slot="{ item }">
              <v-chip
                class="ml-4"
                :clickable="isClickable"
                @click="openClaimsByCondition(item.CATEGORY, 'D')"
                >{{ item.CATEGORY }}</v-chip
              >
            </template>
          </v-virtual-scroll>
        </v-skeleton-loader>
      </v-card>
    </v-col>

    <v-col cols="12" lg="6" class="py-0">
      <v-card v-if="patientConditions">
        <v-card-title>
          <div class="flex-grow-1">
            {{ this.patientConditions.chronic ? this.patientConditions.chronic.length : 0 }} Chronic
            Condition(s)
          </div>
        </v-card-title>

        <v-skeleton-loader :loading="loading" max-width="275" type="card">
          <v-virtual-scroll
            :items="patientConditions.chronic"
            :item-height="40"
            bench="5"
            height="200"
          >
            <template v-slot="{ item }">
              <v-chip
                class="ml-4"
                :clickable="isClickable"
                @click="openClaimsByCondition(item.Translation, 'C')"
                >{{ item.Translation }}</v-chip
              >
            </template>
          </v-virtual-scroll>
        </v-skeleton-loader>
      </v-card>
    </v-col>

    <ClaimsByCondition
      :insurance="insurance"
      :patient="patient"
      :condition="selectedConditionName"
      :conditionType="selectedConditionType"
      v-model="claimsByCondDialog"
    />
  </v-row>
</template>
<script>
import axios from 'axios';
import ClaimsByCondition from './claimsByCondition.vue';

export default {
  name: 'PatientConditions',
  props: ['patient', 'insurance'],
  components: {
    ClaimsByCondition,
  },
  data() {
    return {
      loading: false,
      claimFundTypesDialog: false,
      claimFundsClaimID: '',
      claimsByCondDialog: false,
      selectedConditionName: '',
      selectedConditionType: '',
      patientConditions: [],
    };
  },
  mounted() {
    if (this.patient && this.insurance) {
      this.getClaims();
    }
  },
  methods: {
    async getClaims() {
      this.loading = true;
      console.log(this.patient, this.insurance);
      await axios
        .get(`/api/patient/conditions/all/${this.insurance}/${this.patient}`)
        .then((response) => {
          [this.patientConditions] = response.data;
          console.log(this.patientConditions);
          this.loading = false;
        });
    },
    async openClaimsByCondition(conditionName, conditionType) {
      if (this.isClickable) {
        this.claimsByCondDialog = true;
        this.selectedConditionName = conditionName;
        this.selectedConditionType = conditionType;
      }
    },
  },
  computed: {
    isClickable() {
      return true;
    },
  },
};
</script>
